import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
`;

export default function Reviews({ id }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!id || typeof window === "undefined" || !container) return undefined;

    const loadWidget = () => {
      const s = document.createElement("script");
      s.async = true;
      s.defer = true;
      s.src = `https://cdn.trustindex.io/loader.js?${id}`;
      container.appendChild(s);
    };

    // The widget is a third-party script with its own network and main-thread cost,
    // so only fetch it when it is about to scroll into view.
    if (!("IntersectionObserver" in window)) {
      loadWidget();
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          loadWidget();
        }
      },
      { rootMargin: "400px 0px" }
    );
    observer.observe(container);

    return () => observer.disconnect();
  }, [id]);

  return <Wrapper ref={containerRef} />;
}

Reviews.propTypes = {
  id: PropTypes.string.isRequired,
};
